/* eslint-disable no-template-curly-in-string */
import * as yup from "yup";

const REQ = "El campo ${label} es obligatorio.";

const evidenciaNoVacia = (ev) => {
  return !(
    ev == null ||
    ev === "" ||
    (Array.isArray(ev) && ev.length === 0) ||
    (typeof ev === "object" &&
      !Array.isArray(ev) &&
      !ev.base64 &&
      !ev.url &&
      !ev.file)
  );
};

const requisicionValidacionEsquema = yup.object().shape({
  prioridadId: yup.mixed().required(REQ).label("Prioridad"),
  tipoId: yup.mixed().required(REQ).label("Tipo"),
  departamentoId: yup.mixed().required(REQ).label("Departamento"),
  almacenId: yup.mixed().required(REQ).label("Almacén Destino"),

  estatusId: yup.mixed().required(REQ).label("Estatus"),

  cantidad: yup
    .number()
    .typeError("El campo ${label} debe ser numérico.")
    .moreThan(0, "El campo ${label} debe ser mayor a 0.")
    .required(REQ)
    .label("Cantidad"),
  evidencia: yup
    .mixed()
    .test("evidencia-required", REQ, evidenciaNoVacia)
    .label("Evidencia"),

  comentarios: yup.mixed().required(REQ).label("Requerimiento"),

  almacenSeguridad: yup.boolean().label("Almacén de Seguridad"),

  unidadId: yup.mixed().when("almacenSeguridad", {
    is: true,
    then: (s) => s.notRequired().label("No Económico"),
    otherwise: (s) => s.required(REQ).label("No Económico"),
  }),
});

export default requisicionValidacionEsquema;
